import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
const BASE_URL = process.env.REACT_APP_MAIN_URL

export const ReportDownload = createAsyncThunk(
  "report/ReportDownload",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/report-by-all-data/`, data)
    return response.data
  }
);

export const ReportDownloadByCategoryVertical = createAsyncThunk(
  "report/ReportDownloadByCategoryVertical",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/report-by-category-vertical/`, data)
    return response.data
  }
);

export const ReportDownloadByCategoryHorizontal = createAsyncThunk(
  "report/ReportDownloadByCategoryHorizontal",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/report-by-category-vs-company/`, data)
    return response.data
  }
);

export const ReportDownloadByCategoryVsBrand = createAsyncThunk(
  "report/ReportDownloadByCategoryVsBrand",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/report-by-category-vs-brand/`, data)
    return response.data
  }
);

export const ReportDownloadByDepartmentVsCategory = createAsyncThunk(
  "report/ReportDownloadByDepartmentVsCategory",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/report-by-department-vs-category/`, data)
    return response.data
  }
);